import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {rutClean} from 'rut-helpers';
import {AuthenticationService} from 'src/app/services/authentication/authentication.service';
import {verifiedInvalid} from 'src/app/shared/helpers';
import {forbiddenRut} from 'src/app/shared/rut.validator';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

@Component({
  selector: 'app-modal-recuperar-contrasena',
  templateUrl: './modal-recuperar-contrasena.component.html',
  styleUrls: ['./modal-recuperar-contrasena.component.scss']
})
export class ModalRecuperarContrasenaComponent implements OnInit {

  recoverForm: FormGroup;
  snackbarConfig: MatSnackBarConfig = { panelClass: 'account-request-snackbar', duration: 5000 };
  loading = false;
  result = {
    title: 'Solicitud exitosa',
    message: `Se ha enviado un correo electrónico para restablecer su contraseña, verifique su correo.`,
    show: false,
  };


  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    public bsModalRef: BsModalRef,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.recoverForm = this.fb.group({
      rut: ['', [Validators.required, forbiddenRut()]],
      email: ['', [Validators.required, Validators.email]],
      recaptcha: ['']
    });
  }

  addGuion(rut: string): string {
    return rut.substring(0, rut.length - 1) + '-' + rut.substring(rut.length - 1, rut.length);
  }

  get invalidRut(): boolean {
    return verifiedInvalid(this.recoverForm.get('rut'));
  }

  get invalidEmail(): boolean {
    return verifiedInvalid(this.recoverForm.get('email'));
  }

  get rutProveedor(): string {
    return this.recoverForm.get('rut').value;
  }

  get email(): string {
    return this.recoverForm.get('email').value;
  }

  async submit() {
    this.loading = true;
    const request = {
      rutProveedor: this.addGuion(rutClean(this.rutProveedor)),
      email: this.email
    };
    try {
      const response = await this.authService.recoverPassword(request, this.recoverForm.get('recaptcha').value);
      if (response.status === 'Ok') {
        this.loading = false;
        console.log('Se envió el correo');
        this.result.show = true;
      }
    } catch (error) {
      this.snackBar.open('Ha ocurrido un problema procesando su solicitud', 'cerrar', this.snackbarConfig);
      this.loading = false;
    }
  }
}
